import type { MandataryDto } from '@/lib/api/schemas';

import type { MandataryFormType } from '@/schema/Mandatary.schema';

export const toNum = (v: unknown): number => {
  if (typeof v === 'number') return v;
  if (typeof v === 'string' && v.trim() !== '') return Number(v);
  return 0;
};

export const toNullIfEmpty = (casted: unknown, original: unknown) => {
  if (original === '') return null;
  return casted;
};

export const toFile = (val: unknown): File | null => {
  const v = Array.isArray(val) ? (val[0] ?? null) : (val ?? null);

  if (v instanceof File) return v;

  if (
    v
    && typeof v === 'object'
    && typeof v.name === 'string'
    && typeof v.size === 'number'
    && typeof v.type === 'string'
  ) {
    return v as File;
  }
  return null;
};

export const toMandataryFormType = (mandatary: MandataryDto): MandataryFormType => {
  if (!mandatary.id) throw new Error('Mandatary id is required');
  const firstName = mandatary.firstName?.trim();
  const lastName = mandatary.lastName?.trim();

  return {
    id: mandatary.id,
    email: mandatary?.email ?? '',
    label: firstName && lastName ? `${firstName} ${lastName}` : firstName ?? lastName ?? '',
    phoneNumber: mandatary.phoneNumber ?? '',
    siret: mandatary.siret ?? '',
  };
};
